import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getLanguageCookies } from '../../../utils/content-utils';

function HtmlText(props) {
     const tenantHtml = useSelector(state => state.tenant.tenantHtmlContent);
    let language = getLanguageCookies();
    const htmlData = tenantHtml?.['htmlContents'] || {};
    const contentObj = htmlData?.[props.content];
    let htmlString = '';
    if (contentObj && typeof contentObj === 'object') {
        htmlString = contentObj[language];
        //console.log('HtmlText1', htmlString);
        if (!htmlString) {
            htmlString = contentObj['en'] || '';
        }
    }
    return htmlString ? (
        <div dangerouslySetInnerHTML={{ __html: htmlString }} />
    ) : null;
}
HtmlText.propTypes = {
    id: PropTypes.string,
    content: PropTypes.string,
};
export default HtmlText;
